if (!customElements.get('photo-print-viewer')) {
  customElements.define('photo-print-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.abort && !this.abort.signal.aborted) return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.dialog=this.querySelector('dialog');
      this.stage=this.querySelector('[data-viewer-stage]');
      this.image=this.querySelector('[data-viewer-image]');
      this.status=this.querySelector('[data-viewer-status]');
      this.pointers=new Map();
      this.scale=1;this.x=0;this.y=0;
      this.addEventListener('click',event=>{
        const opener=event.target.closest('[data-viewer-open]');
        if(opener)this.open(opener);
        if(event.target.closest('[data-viewer-close]'))this.dialog.close();
        if(event.target.closest('[data-viewer-fit]'))this.fit();
        const zoom=event.target.closest('[data-viewer-zoom]');
        if(zoom)this.zoom(this.scale+Number(zoom.dataset.viewerZoom)*0.5);
      },options);
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.dialog.close();},options);
      this.dialog.addEventListener('close',()=>{
        this.pointers.clear();this.gesture=null;
        this.opener?.focus({preventScroll:true});
      },options);
      this.dialog.addEventListener('keydown',event=>{
        if(event.key==='Tab'){
          const controls=[...this.dialog.querySelectorAll('button,[tabindex]')].filter(node=>!node.disabled&&node.tabIndex>=0&&node.getClientRects().length);
          const first=controls[0],last=controls.at(-1);
          if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
          else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
        }
        if(event.target!==this.stage)return;
        if(['+','=','-','0','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))event.preventDefault();
        if(event.key==='+'||event.key==='=')this.zoom(this.scale+0.5);
        if(event.key==='-')this.zoom(this.scale-0.5);
        if(event.key==='0')this.fit();
        if(event.key==='ArrowLeft')this.x+=40;
        if(event.key==='ArrowRight')this.x-=40;
        if(event.key==='ArrowUp')this.y+=40;
        if(event.key==='ArrowDown')this.y-=40;
        this.paint();
      },options);
      this.stage.addEventListener('pointerdown',event=>{
        if(event.pointerType==='mouse'&&event.button!==0)return;
        this.stage.setPointerCapture(event.pointerId);
        this.pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
        this.startGesture();
      },options);
      this.stage.addEventListener('pointermove',event=>{
        if(!this.pointers.has(event.pointerId))return;
        this.pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
        const points=[...this.pointers.values()];const g=this.gesture;
        if(!g)return;
        if(points.length===2&&g.distance){
          const center={x:(points[0].x+points[1].x)/2,y:(points[0].y+points[1].y)/2};
          const distance=Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y);
          this.scale=Math.max(1,Math.min(4,g.scale*distance/g.distance));
          const box=this.stage.getBoundingClientRect();const ratio=this.scale/g.scale;
          this.x=center.x-box.left-box.width/2-(g.center.x-box.left-box.width/2-g.x)*ratio;
          this.y=center.y-box.top-box.height/2-(g.center.y-box.top-box.height/2-g.y)*ratio;
        }else if(points.length===1){this.x=g.x+points[0].x-g.center.x;this.y=g.y+points[0].y-g.center.y;}
        this.paint();
      },options);
      for(const name of ['pointerup','pointercancel','lostpointercapture'])this.stage.addEventListener(name,event=>{this.pointers.delete(event.pointerId);this.startGesture();},options);
      this.image.addEventListener('load',()=>{this.status.textContent='';this.fit();},options);
      this.image.addEventListener('error',()=>{this.status.textContent=this.dataset.error;},options);
      this.observer=new ResizeObserver(()=>{if(this.dialog.open)this.fit();});
      this.observer.observe(this.stage);
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();if(this.dialog?.open)this.dialog.close();}
    open(opener = this.querySelector('[data-viewer-open]')){
      if(this.dialog.open)return;
      this.opener=opener;
      this.image.alt=this.querySelector('.photo-print__image').alt;
      this.image.width=Number(this.dataset.width);this.image.height=Number(this.dataset.height);
      const url=new URL(this.dataset.image,location.origin);
      url.searchParams.set('width',Math.min(Number(this.dataset.width)||2400,2400));
      if(this.image.src!==url.href){this.status.textContent=this.dataset.loading;this.image.src=url.href;}
      this.dialog.showModal();this.fit();this.querySelector('[data-viewer-close]').focus();
    }
    fit(){
      const width=this.image.naturalWidth||Number(this.dataset.width);
      const height=this.image.naturalHeight||Number(this.dataset.height);
      if(!width||!height)return;
      const box=this.stage.getBoundingClientRect();
      const ratio=Math.min(box.width/width,box.height/height);
      this.fittedWidth=width*ratio;this.fittedHeight=height*ratio;
      this.image.style.width=this.fittedWidth+'px';this.image.style.height=this.fittedHeight+'px';
      this.scale=1;this.x=0;this.y=0;this.pointers.clear();this.gesture=null;this.paint();
    }
    startGesture(){
      const points=[...this.pointers.values()];
      if(!points.length){this.gesture=null;return;}
      this.gesture={scale:this.scale,x:this.x,y:this.y,center:points.length===2?{x:(points[0].x+points[1].x)/2,y:(points[0].y+points[1].y)/2}:points[0],distance:points.length===2?Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y):0};
    }
    zoom(value){this.scale=Math.max(1,Math.min(4,value));this.paint();}
    paint(){
      const box=this.stage.getBoundingClientRect();
      const maxX=Math.max(0,((this.fittedWidth||0)*this.scale-box.width)/2);
      const maxY=Math.max(0,((this.fittedHeight||0)*this.scale-box.height)/2);
      this.x=Math.max(-maxX,Math.min(maxX,this.x));this.y=Math.max(-maxY,Math.min(maxY,this.y));
      this.image.style.transform=`translate(${this.x}px,${this.y}px) scale(${this.scale})`;
      this.stage.style.cursor=this.scale>1?'grab':'default';
      this.querySelector('[data-viewer-zoom="-1"]').disabled=this.scale<=1;
      this.querySelector('[data-viewer-zoom="1"]').disabled=this.scale>=4;
    }
  });
}
